<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'

  let self, timelines = [], triggers = []

  onMount(() => {
    self.querySelectorAll('.half').forEach(half => {
      const tl = gsap.timeline()
      tl.from(half.querySelectorAll('.person'), {
        opacity: 0,
        scale: 0.7,
        transformOrigin: '50% 50%',
        stagger: .1,
        ease: 'power2.out',
        duration: .5,
      }, 0.3)
      tl.from(half.querySelectorAll('.tv path'), {
        opacity: 0,
        scale: 0.7,
        transformOrigin: '50% 50%',
        stagger: .1,
        ease: 'power2.out',
        duration: .5,
      }, 0)
      half.querySelectorAll('.lines line').forEach(line => {
        tl.from(line, {
          attr: {
            x2: line.getAttribute('x1'),
            y2: line.getAttribute('y1'),
          },
          opacity: 0,
          ease: 'power2.out',
          duration: .5
        }, 0.75)
      })
      const st = ScrollTrigger.create({
        trigger: half,
        start: 'top bottom-=80',
        animation: tl,
        toggleActions: 'play play play pause'
      })
      triggers.push(st)
      timelines.push(tl)
    })

    gsap.to(self.querySelectorAll('.lines line'), {
      strokeDashoffset: -4,
      ease: 'none',
      duration: .5,
      repeat: -1
    })
  })


  onDestroy(() => {
    timelines.map(tl => tl.kill())
    triggers.map(st => st.kill())
  })

</script>

<div class="diagram" bind:this={self}>
  <svg class="top-half half" width="78" height="182" viewBox="0 0 78 182" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g class="people">
      <g class="person">
        <path d="M65.9586 132.223H63.8367H63.508H51.9273H51.5969H49.4755C47.98 132.223 46.7653 133.437 46.7653 134.932V134.971V139.412V154.529C46.7653 155.616 47.7301 156.5 48.9199 156.5H48.9633C50.1526 156.5 51.1173 155.616 51.1173 154.529V139.045C51.2231 139.021 51.334 139.006 51.4477 139.006C51.4989 139.006 51.5462 139.014 51.5969 139.018V152.666V155.336V178.884C51.5969 180.376 52.8053 181.587 54.2969 181.587H54.3509C55.8436 181.587 57.0526 180.377 57.0526 178.884V155.292C57.2445 155.165 57.4697 155.089 57.7179 155.089C57.965 155.089 58.1918 155.167 58.3843 155.294C58.3843 155.318 58.3809 155.341 58.3809 155.366V178.884C58.3809 180.375 59.59 181.587 61.081 181.587H61.1367C62.6288 181.587 63.8389 180.377 63.8389 178.884V155.366C63.8389 155.355 63.8367 155.346 63.8367 155.336H63.8389V139.018C63.8896 139.013 63.9369 139.006 63.9898 139.006C64.104 139.006 64.2127 139.021 64.3207 139.044V154.528C64.3207 155.616 65.2849 156.499 66.4748 156.499H66.5181C67.7074 156.499 68.6705 155.616 68.6705 154.528V139.412V134.97V134.932C68.6682 133.437 67.4564 132.223 65.9586 132.223Z"/>
        <path d="M62.5675 126.435C62.5675 129.114 60.3966 131.283 57.7191 131.283C55.041 131.283 52.8724 129.113 52.8724 126.435C52.8724 123.759 55.0416 121.587 57.7191 121.587C60.396 121.587 62.5675 123.759 62.5675 126.435Z"/>
      </g>
    </g>
    <g class="people">
      <g class="person">
        <path d="M32.8207 150.235L28.189 134.35C27.7494 132.844 26.3704 131.808 24.8006 131.808H23.4751H19.9448H16.4152H15.0891C13.521 131.808 12.1409 132.844 11.7018 134.35L7.07012 150.235C6.76675 151.278 7.48157 152.34 8.56169 152.452L9.01197 152.496C9.85625 152.581 10.6403 152.045 10.8615 151.226L14.282 138.714C14.282 138.714 14.4908 138.53 14.7323 138.542L8.91178 161.818H14.7778V178.866C14.7778 180.228 15.7443 181.33 16.9353 181.33H16.978C18.1707 181.33 19.1349 180.228 19.1349 178.866V161.818H19.9443H20.7537V178.866C20.7537 180.228 21.7201 181.33 22.9116 181.33H22.9544C24.1471 181.33 25.1113 180.228 25.1113 178.866V161.818H30.9773L25.1586 138.542C25.3983 138.53 25.6094 138.714 25.6094 138.714L29.027 151.226C29.2505 152.045 30.0351 152.581 30.8783 152.496L31.3291 152.452C32.4087 152.34 33.1252 151.278 32.8207 150.235Z"/>
        <path d="M19.9444 131C22.5034 131 24.5779 128.926 24.5779 126.367C24.5779 123.808 22.5034 121.733 19.9444 121.733C17.3855 121.733 15.311 123.808 15.311 126.367C15.311 128.926 17.3855 131 19.9444 131Z"/>
      </g>
    </g>
    <g class="tv">
      <path d="M78 0H0V48.1818H24.375L26.8103 53H51.1853L53.6207 48.1818H78V0ZM73.125 43.3679H4.875V4.82246H73.125V43.3679Z" />
    </g>
    <g class="lines">
      <line x1="57.5" y1="116.5" x2="57.5" y2="18.5"/>
      <line x1="19.5" y1="116.5" x2="19.5" y2="18.5"/>
    </g>
  </svg>
  <svg class="bot-half half" width="285" height="182" viewBox="0 0 285 182" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g class="people">
      <g class="person">
        <path d="M170.959 132.223H168.837H168.508H156.927H156.597H154.475C152.98 132.223 151.765 133.437 151.765 134.932V134.971V139.412V154.529C151.765 155.616 152.73 156.5 153.92 156.5H153.963C155.153 156.5 156.117 155.616 156.117 154.529V139.045C156.223 139.021 156.334 139.006 156.448 139.006C156.499 139.006 156.546 139.014 156.597 139.018V152.666V155.336V178.884C156.597 180.376 157.805 181.587 159.297 181.587H159.351C160.844 181.587 162.053 180.377 162.053 178.884V155.292C162.245 155.165 162.47 155.089 162.718 155.089C162.965 155.089 163.192 155.167 163.384 155.294C163.384 155.318 163.381 155.341 163.381 155.366V178.884C163.381 180.375 164.59 181.587 166.081 181.587H166.137C167.629 181.587 168.839 180.377 168.839 178.884V155.366C168.839 155.355 168.837 155.346 168.837 155.336H168.839V139.018C168.89 139.013 168.937 139.006 168.99 139.006C169.104 139.006 169.213 139.021 169.321 139.044V154.528C169.321 155.616 170.285 156.499 171.475 156.499H171.518C172.707 156.499 173.67 155.616 173.67 154.528V139.412V134.97V134.932C173.668 133.437 172.456 132.223 170.959 132.223Z"/>
        <path d="M167.567 126.435C167.567 129.114 165.397 131.283 162.719 131.283C160.041 131.283 157.872 129.113 157.872 126.435C157.872 123.759 160.042 121.587 162.719 121.587C165.396 121.587 167.567 123.759 167.567 126.435Z"/>
      </g>
    </g>
    <g class="people">
      <g class="person">
        <path d="M137.821 150.235L133.189 134.35C132.749 132.844 131.37 131.808 129.801 131.808H128.475H124.945H121.415H120.089C118.521 131.808 117.141 132.844 116.702 134.35L112.07 150.235C111.767 151.278 112.482 152.34 113.562 152.452L114.012 152.496C114.856 152.581 115.64 152.045 115.862 151.226L119.282 138.714C119.282 138.714 119.491 138.53 119.732 138.542L113.912 161.818H119.778V178.866C119.778 180.228 120.744 181.33 121.935 181.33H121.978C123.171 181.33 124.135 180.228 124.135 178.866V161.818H124.944H125.754V178.866C125.754 180.228 126.72 181.33 127.912 181.33H127.954C129.147 181.33 130.111 180.228 130.111 178.866V161.818H135.977L130.159 138.542C130.398 138.53 130.609 138.714 130.609 138.714L134.027 151.226C134.25 152.045 135.035 152.581 135.878 152.496L136.329 152.452C137.409 152.34 138.125 151.278 137.821 150.235Z"/>
        <path d="M124.944 131C127.503 131 129.578 128.926 129.578 126.367C129.578 123.808 127.503 121.733 124.944 121.733C122.385 121.733 120.311 123.808 120.311 126.367C120.311 128.926 122.385 131 124.944 131Z"/>
      </g>
    </g>
    <g class="tv">
      <path d="M183 0H105V48.1818H129.375L131.81 53H156.185L158.621 48.1818H183V0ZM178.125 43.3679H109.875V4.82246H178.125V43.3679Z" />
      <path d="M285 46H206V96H230.687L233.154 101H257.842L260.308 96H285V46ZM280.062 91.0044H210.937V51.0044H280.062V91.0044Z" />
      <path d="M79 47H0V97H24.6875L27.1541 102H51.8416L54.3081 97H79V47ZM74.0625 92.0044H4.9375V52.0044H74.0625V92.0044Z" />
    </g>
    <g class="lines">
      <line x1="162.5" y1="116.5" x2="162.5" y2="18.5"/>
      <line x1="124.5" y1="116.5" x2="124.5" y2="18.5"/>
      <line x1="156.5" y1="118" x2="64" y2="65"/>
      <line x1="119" y1="118" x2="27" y2="65"/>
      <line x1="168" y1="118" x2="260" y2="65"/>
      <line x1="130.75" y1="118" x2="222.5" y2="65"/>
    </g>
  </svg>
  
</div>


<style>
  .lines {
    stroke: var(--verizon-red);
    stroke-linecap: round;
    stroke-dasharray: 1 3;
  }
  .people {
    fill: var(--verizon-red)
  }
  .tv {
    fill: white
  }
  svg {
    margin: auto;
  }
  .bot-half {
    margin-top: 60px;
  }
  @media(min-width: 768px) {
    svg {
      height: 220px;
      width: auto;
    }
    .diagram {
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 720px;
      margin: auto;
    }
    .bot-half {
      margin: 0 10% 0 0;
    }
    .top-half {
      margin: 0 0 0 10%;
    }
  }
  @media(min-width: 1024px) {
    svg {
      height: 296px;
    }
    .bot-half,
    .top-half {
      margin: 0;
    }
    .lines {
      stroke-width: 0.75
    }
  }
</style>